<template>
  <VList :meta="meta">
    <template #before>
      <VListHeader />
    </template>

    <template v-if="isLoading" #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        <Loader />
      </div>
    </template>

    <template v-else-if="isRejected" #default>
      <div class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center">
        Something went wrong. Please try again later.
      </div>
    </template>

    <template v-else-if="productionOrders.length" #default>
      <template v-for="productionOrder in productionOrders">
        <VListLine
          :key="`productionOrders_${productionOrder.uuid}`"
          :production-order="productionOrder"
          :focus="lastEditedProductionOrderItemId === (productionOrder.orderItems || [])[0]"
          :disabled="isLoading"
          @production-order-item:view="$emit('production-order-item:view', $event)"
        />
      </template>
    </template>

    <template v-else #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        No results found
      </div>
    </template>
  </VList>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import VList from '@/components/Common/VList.vue';
import VListHeader from './VListHeader.vue';
import VListLine from './VListLine.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

const includes = 'order_items,provider,project';

export default {
  name: 'ProductionOrderList',

  components: {
    VList,
    VListHeader,
    VListLine,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    lastEditedProductionOrderItemId: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    status: STATUS_IDLE,
  }),

  computed: {
    ...mapState('ui/productionOrders', ['meta']),
    ...mapGetters('ui/productionOrders', ['productionOrders']),
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('ui/productionOrders', {
      loadProductionOrders: 'load',
    }),

    ...mapMutations('ui/productionOrders', ['setIds', 'setMeta', 'setLinks']),

    async fetchData() {
      const {
        query: { sort = '', ...restQuery },
      } = this.$route;

      const sortParams = sort.split(',');
      sortParams.push('-created_at');

      this.status = STATUS_PENDING;

      try {
        await this.loadProductionOrders({
          params: {
            ...restQuery,
            filter: {
              account_relation_with: this.accountId,
            },
            include: includes,
            sort: sortParams.join(','),
          },
        });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;
      }
    },
  },
};
</script>
